import { useState } from 'react';
import { faqs } from '@/mocks/posts';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 px-4 py-10 md:px-8" aria-labelledby="faq-heading">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 id="faq-heading" className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于本站，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            还没解答你的疑问？写信到 tips@18bolaodaily.example，我们会在一个工作日内回复。
          </p>
        </div>

        <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</h3>
                  <i
                    className={`shrink-0 text-lg text-primary-500 ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}